import { supabaseClient } from '../config/supabase';

async function sessionBearerToken() {
    const { data } = await supabaseClient.auth.getSession();
    return data?.session?.access_token || null;
}

export async function requestAffiliateTripLink(assignmentId, method) {
    const token = await sessionBearerToken();
    if (!token) throw new Error('Sign in again to manage affiliate links.');

    const options = {
        method,
        headers: {
            Authorization: ['Bearer', token].join(' '),
        },
    };

    let url = `/api/affiliate/trip-links?assignmentId=${encodeURIComponent(assignmentId)}`;
    if (method === 'POST') {
        url = '/api/affiliate/trip-links';
        options.headers['Content-Type'] = 'application/json';
        options.body = JSON.stringify({ assignmentId });
    }

    const response = await fetch(url, options);
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) {
        const error = new Error(payload?.error || 'affiliate_link_request_failed');
        error.status = response.status;
        throw error;
    }
    return payload?.link || null;
}

export function shouldAutoMintAffiliateTripLink({ assignmentType, driver } = {}) {
    return assignmentType === 'affiliate' && driver?.employment_classification === '1099_affiliate';
}
